export class Exception extends Error {}

export class AccessException extends Exception {
  message = 'Unauthorized'
}
